/**
 * Sentinel option values for the delivery-task selects. Radix Select can't hold
 * an empty-string value, so "nothing chosen" needs a stand-in that maps back to
 * null before it reaches the database.
 */
export const BACKLOG_VALUE = "__backlog__";
export const NO_BLOCK_VALUE = "__no_block__";
export const UNASSIGNED_VALUE = "__unassigned__";
